/**
 * Core API Configuration
 * Only contains base URLs - packages add their own paths
 */
// Get environment variable from Vite (build-time injection)
const getViteEnvVar = (name) => {
    // Vite injects import.meta.env at build time
    if (typeof import.meta !== 'undefined' && import.meta.env) {
        return import.meta.env[name];
    }
    return undefined;
};
// Get backend URL from environment or throw error
const getBackendUrl = () => {
    // Try Vite env first
    const viteUrl = getViteEnvVar('VITE_API_URL');
    if (viteUrl)
        return viteUrl;
    // For Node.js environments
    if (typeof process !== 'undefined' && process.env?.VITE_API_URL) {
        return process.env.VITE_API_URL;
    }
    // Development fallback - only if no env var is set
    if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'development') {
        console.warn('⚠️ VITE_API_URL not set, using development fallback');
        return 'http://localhost:3001';
    }
    throw new Error('VITE_API_URL environment variable is not set. Please set it in your .env file.');
};
// Get frontend URL from environment
const getFrontendUrl = () => {
    const viteUrl = getViteEnvVar('VITE_FRONTEND_URL');
    if (viteUrl)
        return viteUrl;
    if (typeof process !== 'undefined' && process.env?.VITE_FRONTEND_URL) {
        return process.env.VITE_FRONTEND_URL;
    }
    // Development fallback
    if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'development') {
        return 'http://localhost:3000';
    }
    return 'http://localhost:3000'; // Safe fallback for frontend
};
export const API_CONFIG = {
    BASE_URLS: {
        // ✅ Base URLs only - no specific paths
        backend: getBackendUrl(),
        frontend: getFrontendUrl()
    },
    DEFAULTS: {
        timeout: 10000,
        retries: 3,
        headers: {}
    },
    AUTH: {
        tokenKey: 'textile_erp_token',
        tokenHeader: 'Authorization',
        tokenPrefix: 'Bearer'
    }
};
/**
 * Helper functions to construct URLs
 */
// A path that is already a full URL (e.g. an uploaded file's direct bucket URL) is returned as is
export const buildBackendUrl = (path) => /^https?:\/\//i.test(path) ? path : `${API_CONFIG.BASE_URLS.backend}${path}`;
export const buildFrontendUrl = (path) => `${API_CONFIG.BASE_URLS.frontend}${path}`;
// Note: These are examples only. Always use VITE_API_URL from .env
export const ENVIRONMENTS = {
    development: {
        backend: getViteEnvVar('VITE_API_URL') || 'USE_ENV_VARIABLE',
        frontend: getViteEnvVar('VITE_FRONTEND_URL') || 'USE_ENV_VARIABLE'
    },
    staging: {
        backend: getViteEnvVar('VITE_API_URL') || 'USE_ENV_VARIABLE',
        frontend: getViteEnvVar('VITE_FRONTEND_URL') || 'USE_ENV_VARIABLE'
    },
    production: {
        backend: getViteEnvVar('VITE_API_URL') || 'USE_ENV_VARIABLE',
        frontend: getViteEnvVar('VITE_FRONTEND_URL') || 'USE_ENV_VARIABLE'
    }
};
/**
 * Get environment-specific configuration
 */
export const getApiConfig = (env) => {
    const nodeEnv = env || (typeof process !== 'undefined' && process.env?.NODE_ENV) || 'development';
    return ENVIRONMENTS[nodeEnv] || ENVIRONMENTS.development;
};
//# sourceMappingURL=api-config.js.map